












































import { defineComponent, toRefs, PropType, computed, ref, watch, onMounted } from '@vue/composition-api';
import {
  AdgroupFormData,
  FullNormalFormData,
  AcoFormData,
  CreativeConfig,
  PixelInfo,
  ACTION_TYPE,
} from '@tt4b/ttam-enums';
import { useStore } from '@tt4b/ttam-hooks';
import { trackEvent } from './../../../utils/index';
import { useWebsiteEvents } from './hooks/useWebsiteEventsRefactored';
import TtamWebsiteEventsPixelEcho from './website-events/pixel-echo.vue';
import PixelListSelectInfiniteScroll from '@/components/common/pixel-list-select/pixel-list-select-infinite-scroll.vue';
import TtamTrackingDataEmpty from './tracking-data-empty.vue';
import { usePixelList } from './hooks/usePixelList';

const name = 'ttam-ad-tracking-website-events-compose-refactored';
export default defineComponent({
  name,
  components: {
    PixelListSelectInfiniteScroll,
    TtamWebsiteEventsPixelEcho,
    TtamTrackingDataEmpty,
  },
  props: {
    copyNum: {
      type: Number as PropType<number>,
      default: 20,
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<typeof ACTION_TYPE[keyof typeof ACTION_TYPE]>,
      default: ACTION_TYPE.CREATE,
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    adGroupPixelInfo: {
      type: Object as PropType<PixelInfo>,
      default: () => ({}),
    },
    creativeConfig: {
      type: Object as PropType<CreativeConfig>,
      default: () => ({}),
    },
    alwaysFetchOffSite: {
      type: Boolean,
      default: false,
    },
    isNewTiktokEventTrack: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, adGroupPixelInfo, createMode, creativeData, creativeConfig, copyNum } = toRefs(props);
    const { state } = useStore();

    const aadvid = computed(() => state.baseInfo.value.aadvid);

    const { disabled, pixelLabel, isOffSitePixel, addPixelLink, isPixelItemDisabled, getCurrentPixelInfo } =
      useWebsiteEvents({
        copyNum,
        adgroupData,
        creativeConfig,
        adGroupPixelInfo,
        createMode,
        creativeData,
        aadvid,
      });

    const _trackingPixelId = computed({
      get: () => creativeData.value?.trackingPixelId || '',
      set: (val: string) => {
        emit('change', val);
      },
    });

    const currentPixelInfo = ref([]);
    // 确保第一次加载组件时加载列表
    watch(
      _trackingPixelId,
      async () => {
        if (
          !isOffSitePixel.value &&
          _trackingPixelId.value &&
          currentPixelInfo.value[0]?.id !== _trackingPixelId.value
        ) {
          const pixelInfo = await getCurrentPixelInfo();
          currentPixelInfo.value = [pixelInfo];
        }
      },
      { immediate: true },
    );

    /** 选中pixel事件 */
    const onPixelChange = pixelItem => {
      trackEvent('select_ad_tracking_pixel');
      const { id } = pixelItem;
      if (id) {
        currentPixelInfo.value = [pixelItem];
      }
      _trackingPixelId.value = id ?? '';
      console.warn(666, pixelItem);

      if (!id) {
        trackEvent('delete_ad_tracking_pixel');
      }
    };

    const { oriPixelList, loadPixelList, loading } = usePixelList(adgroupData.value);
    onMounted(() => {
      if (oriPixelList.value.length === 0) {
        loadPixelList();
      }
    });

    return {
      name,
      pixelLabel,
      isOffSitePixel,
      _trackingPixelId,
      disabled,
      oriPixelList,
      loading,
      addPixelLink,

      currentPixelInfo,
      onPixelChange,
      isPixelItemDisabled,
    };
  },
});
